import { createStyles } from '@asuikit/styles';

export default createStyles({
  root: {
    position: 'relative',
  },

  label: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  },
});
